/**
 * Scroll an element into view, instantly and synchronously. Every in-page
 * anchor (the header's email item → the pending card, the Stats drill-down →
 * a Matching card, the leakage tile) used `behavior: 'smooth'`; a smooth
 * scroll, like a requestAnimationFrame callback, waits for a frame, and a tab
 * that is not in front never gets one - the page simply stayed at the top
 * (live check 2026-09-16, while the tab was in the background). An instant
 * scrollIntoView needs no frame and works in front or behind. Returns
 * whether there was something to jump to.
 */
export function jumpTo(el: Element | null | undefined, block: ScrollLogicalPosition = 'start'): boolean {
  if (!el) return false;
  el.scrollIntoView({ block });
  return true;
}
